// extracted by mini-css-extract-plugin
export default {"container":"Grid_container__HVHDp","rows":"Grid_rows__72zZd","columns":"Grid_columns__5g5q+","rowBorder":"Grid_rowBorder__ahB4Q","columnBorder":"Grid_columnBorder__+S0t7"};